import React from "react";
import styled from "styled-components";
import Icon from "@material-ui/core/Icon";

const MessageContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  padding: 16px 16px 0px 16px;
  margin: 0 auto;
  max-width: 1600px;
  @media (max-width: 1200px) {
    flex-direction: column;
  }

  @media (max-width: 900px) {
    padding: 18px 8px;
  }
`;

const CardMessage = styled.div`
  /* background: linear-gradient(28deg, #f44336, #dd2446); */
  background: ${(props) => props.backgroundColorMap};;
  border: 1px solid ${(props) => props.color};
  border-radius: 8px;
  box-shadow: 0px 0px 8px 0px #e1e2e6;
  /* color: ${(props) => props.color}; */
  display: flex;
  align-items: center;
  font-family: ${(props) => props.theme.font.primary};
  font-size: 16px;
  font-weight: 500;
  width: 100%;
  padding: 16px;

  span {
    color: ${(props) => props.color};
    margin-right: 6px;
  }
`;

const colorMap = {
  yellow: "#F4C136",
  red: "#F44336",
};

const backgroundColorMap = {
  yellow: "#fffaed",
  red: "#ffe7e5",
};

export const Alert = ({ color = "red", message }) => (
  <MessageContainer>
    <CardMessage
      backgroundColorMap={backgroundColorMap[color]}
      color={colorMap[color]}
    >
      <Icon>error_outline</Icon>
      <p>{message}</p>
    </CardMessage>
  </MessageContainer>
);
